import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useOperationStore } from "@/stores/operation";


export default /*#__PURE__*/_defineComponent({
  __name: 'MentionsView',
  setup(__props) {

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);

return { __sfc: true,operationStore, op }
}

})